import React from "react";
import { CheckCircle } from "lucide-react";
import Beautycycle from "./Beautycycle";
import Footer from "../../Home/Footer";
import WhatsAppServices from "../../Home/WhatsAppServices";
import Faqs from "../../Home/Faqs";
// Array for dynamic data
const travelLeadData = {
  heading: "Elevate Your Beauty & Cosmetics Brand with WhatsApp",
  points: [
    "Show off your products with a stunning WhatsApp storefront.",
    "Send exclusive offers to thousands of customers in a snap.",
    "Keep in touch 24/7 with smart WhatsApp automation.",
  ],
  buttons: [
    { text: "Try ChatMitra for Growth", className: "bg-[#075E54] text-white hover:bg-[#064d40]" ,buttonLink:"https://app.chatmitra.com/signin"},
    { text: "Book a Live Demo", className: "border border-[#075E54] text-[#075E54] hover:text-white" },
  ],
  image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Beauty_Cosmetics/Beauty_and_Cosmetics_1.png",
};


const beautyServices = [
  {
    id: 1,
    icon: <span className="text-2xl">💄</span>, // Lipstick icon
    title: "Boost Product Sales with WhatsApp Campaigns",
    description: "Launch exclusive makeup and skincare deals via WhatsApp to drive sales. Customers love the personal touch—it’s like getting a VIP invite from their favorite brand!"
  },
  {
    id: 2,
    icon: <span className="text-2xl">🛍️</span>, // Shopping bag icon
    title: "Simplify Online Orders on WhatsApp",
    description: "Let customers browse, order, and track beauty products directly through WhatsApp. It’s quick, easy, and keeps them coming back for more."
  },
  {
    id: 3,
    icon: <span className="text-2xl">📸</span>, // Camera icon
    title: "Showcase Products with WhatsApp Visuals",
    description: "Share stunning before-and-after photos, tutorials, and product demos via WhatsApp. It’s a visual feast that turns browsers into buyers."
  },
  {
    id: 4,
    icon: <span className="text-2xl">💬</span>, // Chat bubble icon
    title: "Offer Real-Time Beauty Advice on WhatsApp",
    description: "Answer skincare questions, recommend products, and build trust with instant WhatsApp chats. Your customers will feel like they have a personal beauty consultant."
  },
  {
    id: 5,
    icon: <span className="text-2xl">📅</span>, // Calendar icon
    title: "Schedule Spa Appointments via WhatsApp",
    description: "Make booking facials or waxing sessions a breeze with WhatsApp. Customers can confirm, reschedule, or cancel—all in one chat."
  },
  {
    id: 6,
    icon: <span className="text-2xl">⭐</span>, // Star icon
    title: "Gather Feedback with WhatsApp Surveys",
    description: "Ask for reviews, conduct quick polls, and improve your services using WhatsApp. Happy customers mean loyal fans—and more sales!"
  }
];

const beautyFAQs = [
  {
    question: "How can WhatsApp boost sales for my beauty brand?",
    answer: "WhatsApp can skyrocket your sales by sending personalized product offers, launch announcements, and exclusive deals directly to customers. It’s like having a VIP club where they feel special and are more likely to buy!"
  },
  {
    question: "Is WhatsApp good for promoting new cosmetics?",
    answer: "Absolutely! Share stunning visuals, tutorials, and before-after photos via WhatsApp to showcase your latest makeup or skincare lines. It’s a visual feast that turns interest into purchases."
  },
  {
    question: "Can customers order beauty products on WhatsApp?",
    answer: "Yes, and it’s seamless! Customers can browse catalogs, place orders, and track shipments all through WhatsApp. It’s like shopping from their favorite beauty influencer—fast and fun."
  },
  {
    question: "How does WhatsApp help with beauty consultations?",
    answer: "WhatsApp lets you offer real-time advice on skincare routines, product recommendations, or makeup looks. It’s like having a personal beauty expert chatting with clients, building trust and loyalty."
  },
  {
    question: "Can WhatsApp schedule spa or salon appointments?",
    answer: "Definitely! Clients can book facials, waxing, or hair treatments via WhatsApp, with reminders and confirmations sent automatically. It’s a stress-free way to keep your calendar full."
  },
  {
    question: "How do I engage beauty customers on WhatsApp?",
    answer: "Send tips, trends, and loyalty rewards via WhatsApp to keep customers coming back. It’s like nurturing a relationship—regular chats make them feel valued and more likely to repurchase."
  },
  {
    question: "Is WhatsApp secure for sharing beauty product info?",
    answer: "Yes, WhatsApp’s encryption ensures safe sharing of product details, customer data, and payment links. Your clients can trust you, and you can focus on growing your brand."
  },
  {
    question: "Can WhatsApp reduce customer service time for beauty brands?",
    answer: "Absolutely! Automate responses to common questions and handle inquiries via WhatsApp, freeing up your team for creative tasks. It’s like having an assistant who never sleeps!"
  },
  {
    question: "How can I collect feedback using WhatsApp?",
    answer: "Send quick surveys or ask for reviews on products and services via WhatsApp. It’s a simple way to gather insights and show customers you value their opinions."
  },
  {
    question: "What’s the first step to using WhatsApp for my beauty business?",
    answer: "Start by setting up WhatsApp Business, creating a catalog of your products, and training your team to chat professionally. Tools like ChatMitra can help you launch fast and effectively!"
  },
];

const Beauty = () => {
  return (
    <>
      <section className="max-w-6xl mx-auto px-4 py-16 bg-white pt-28">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="w-full lg:w-1/2">
            <h1 className="text-4xl font-bold text-gray-800 mb-6">Elevate Your Beauty & Cosmetics Brand with WhatsApp</h1>
            <ul className="space-y-4 text-gray-700">
              {travelLeadData.points.map((point, index) => (
                <li key={index} className="flex items-start gap-3">
                  <CheckCircle className="text-[#075E54] w-5 h-5 flex-shrink-0" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 flex gap-4">
              {travelLeadData.buttons.map((button, index) => (
                 <a
                 key={index}
                 href={button.buttonLink}
                 className={`py-3 px-6 rounded-lg text-lg font-semibold ${button.className}`}
               >
                 {button.text}
               </a>
              ))}
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <img src={travelLeadData.image} alt="Beauty & Cosmetics Leads" className="w-full h-auto rounded-lg  hover:scale-105 transition-transform" />
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 py-8 text-center">
          <p className="text-lg text-gray-600">Sell more and grow your beauty brand with WhatsApp. Get started with ChatMitra today—no credit card needed!</p>
          <button className="mt-4 bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors">Get Start - No Credit Card Required</button>
        </div>
      </section>

      <Beautycycle />
      <WhatsAppServices servicesData={beautyServices} isVisible={true}/>
      <Faqs faqs={beautyFAQs} />
      <title>Grow Your Beauty & Cosmetics Brand with WhatsApp | ChatMitra</title>
      <meta name="description" content="Boost your beauty & cosmetics business with WhatsApp. Showcase products, send offers, and engage customers with ChatMitra’s automation tools." />
      <meta name="keywords" content="WhatsApp for beauty, cosmetics marketing, beauty eCommerce, WhatsApp storefront, customer engagement, WhatsApp automation" />
      <meta property="og:title" content="Grow Your Beauty & Cosmetics Brand with WhatsApp | ChatMitra" />
      <meta property="og:description" content="Use WhatsApp to promote beauty products, recover carts, and keep customers engaged with personalized campaigns." />
      <meta property="og:url" content="https://blog.chatmitra.com/whatsapp-business-for-beauty-cosmetics-brands" />
      <meta property="og:type" content="website" />
      <Footer />
    </>
  );
};

export default Beauty;
